module.exports = {
  BookingNo: 'Số ủy thác',
  JobNo: 'Số nghiệp vụ',
  ContainerLoadType: 'Loại đóng gói',
  Electric: 'Có pin không',
  ElectricCol: 'Có pin',
  Magnetic: 'Có từ tính không',
  MagneticCol: 'Có từ tính',
  Powdery: 'Có bột không',
  PowderyCol: 'Bột',
  Liquid: 'Có chất lỏng không',
  LiquidCol: 'Chất lỏng',
  DomesticWarehouse: 'Kho nhận hàng',
  PreAmazonWhTime: 'Thời gian dự kiến nhập kho Amazon',
  ServiceChannel: 'Kênh dịch vụ',
  WarehouseCode: 'Mã kho nước ngoài',
  RemoteWarehouse: 'Có phải kho xa không',
  ShippingType: 'Phương thức vận chuyển',
  DestinationDistribution: 'Phương thức giao hàng tại điểm đến',
  overseaWarehouse: 'Kho nước ngoài',
  IncoTerm: 'Điều khoản thương mại',
  PoNumber: 'PO (số đơn gốc)',
  ShipmentId: 'Mã lô hàng',
  ReferenceId: 'Mã tham chiếu',
  ChargingMethod: 'Phương thức tính phí',
  LclMethod: 'Phương thức ghép hàng',
  ValueAddedServices: 'Dịch vụ gia tăng',
  EoriNo: 'EORI/Số doanh nghiệp',
  TaxnoType: 'Loại mã số thuế',
  VatNo: 'VAT/Mã số thuế',
  TaxRegisterCountry: 'Quốc gia đăng ký VAT',
  TaxRegisterAddress: 'Địa chỉ đăng ký VAT',
  TaxCompany: 'Công ty VAT (tên tiếng Anh)',
  PreWarehousingTime: 'Thời gian dự kiến nhập kho',
  QuantityContract: 'Tổng số kiện (ủy thác)',
  WeightContract: 'Tổng trọng lượng (ủy thác)',
  CubageContract: 'Tổng thể tích (ủy thác)',
  VolumetricWeight: 'Thể tích hàng (ủy thác)',
  ChargedWeight: 'Trọng lượng tính phí (ủy thác)',
  QuantityActual: 'Tổng số kiện (thực tế)',
  WeightActual: 'Tổng trọng lượng (thực tế)',
  CubageActual: 'Tổng thể tích (thực tế)',
  QuantityCharge: 'Tổng số kiện (tính phí)',
  WeightCharge: 'Tổng trọng lượng (tính phí)',
  CubageCharge: 'Tổng thể tích (tính phí)',
  BubbleCountingRatio: 'Hệ số tính phí bọt',
  BubbleSplittingRatio: 'Tỷ lệ chia phí bọt',
  PickupService: 'Nhận hàng tận nơi',
  PickupTime: 'Thời gian nhận hàng',
  PickupDoor: 'Điểm nhận hàng',
  DoorMan: 'Người liên hệ',
  DoorManTel: 'Số điện thoại liên hệ',
  DoorAddress: 'Địa chỉ cửa hàng',
  CustomerRequire: 'Yêu cầu khách hàng',
  SubmitState: 'Trạng thái gửi',
  SubmitBy: 'Người gửi',
  importSingleOrder: 'Nhập đơn hàng đơn lẻ',
  batchImportOrder: 'Nhập Loạt ĐH',
  downloadSingleImportTemplate: 'Tải mẫu nhập đơn lẻ',
  downloadBatchImportTemplate: 'Tải mẫu nhập hàng loạt',
  SubmitDate: 'Thời gian gửi',
  VerifyState: 'Trạng thái sơ duyệt',
  VerifyBy: 'Người sơ duyệt',
  VerifyDate: 'Thời gian sơ duyệt',
  UseNewNo: 'Tạo mã nghiệp vụ mới',
  BookingAudit: 'Duyệt đơn hàng',
  ShippingTypeCannotBeEmpty: 'Phương thức vận chuyển không được để trống',
  ChargingMethodCannotBeEmpty: 'Phương thức tính phí không được để trống',
  DomesticWarehouseCannotBeEmpty: 'Kho nhận hàng không được để trống',
  WarehouseCodeCannotBeEmpty: 'Mã kho Amazon không được để trống',
  ContainerLoadTypeCannotBeEmpty: 'Loại ghép hàng không được để trống',
  OperateTypeCannotBeEmpty: 'Chế độ thao tác không được để trống',
  BookingTermCannotBeEmpty: 'Tính chất đặt chỗ không được để trống',
  VerifyRefuseReason: 'Lý do từ chối duyệt',
  ReverifyRefuseReason: 'Lý do từ chối kiểm tra lại',
  CustomerId: 'Đơn vị ủy thác',
  LoadingPortCode: 'Cảng đi',
  Packing: 'Loại đóng gói',
  SingleImport: 'Nhập đơn hàng FBA',
  Op: 'Thao tác',
  Sales: 'Bán hàng',
  Csr: 'Chăm sóc khách hàng',
  Dc: 'Chứng từ',
  CreatedBy: 'Người tạo',
  DateCreated: 'Ngày tạo',
  ExpressCompany: 'Công ty chuyển phát',
  ExpressNo: 'Số vận đơn',
  AmazonWarehouseCode: 'Mã kho Amazon',
  OperationStatusOfForeignWarehouse: 'Trạng thái thao tác kho nước ngoài',
  Cargo_PolStation: 'Ga xuất phát (đường sắt)',
  quotationStatus: 'Trạng thái báo giá',
  quotationObject: 'Đối tượng báo giá',
  hasJob: 'Có nhập đơn hàng không',
  cannotDeleteAddedService: 'Không được phép xóa dịch vụ gia tăng đang được nghiệp vụ sử dụng!',
  changeChannel: 'Kênh dịch vụ hiện tại chưa được duy trì báo giá cho cấp độ khách hàng hiện tại, hệ thống không thể tự động ước tính chi phí, có tiếp tục không?',
  cargoTypeNotExist: 'Kênh dịch vụ hiện tại không tiếp nhận loại hàng {0}, vui lòng cập nhật loại hàng!',
  warehouseCodeNotExist: 'Kênh dịch vụ hiện tại không bao gồm điểm đến {0}, vui lòng cập nhật điểm đến!',
  changeWarehouseCode: 'Điểm đến đã thay đổi, có làm mới chi phí phát sinh tại khu vực của kênh dịch vụ cũ không?',
  changeCustomer: 'Đơn vị ủy thác đã thay đổi có làm mới chi phí phát sinh theo cấp độ khách hàng của kênh dịch vụ cũ không?',
  changeChargeWeight: 'Trọng lượng tính cước đã thay đổi, có làm mới chi phí tính theo trọng lượng cước cũ không? Chi phí đã lập hóa đơn, xuất hóa đơn, yêu cầu thanh toán, đối soát sẽ không được cập nhật',
  refreshCharge: 'Kênh dịch vụ đã thay đổi, có cần làm mới chi phí được tạo theo kênh dịch vụ cũ không?',
  channelInfoCannotChange: '{0} của kênh dịch vụ này không thể thay đổi.',
  changeVerifyShippingType: '{0} Kênh dịch vụ này chỉ hỗ trợ vận chuyển {1}.',
  changeVerifyMultipleShippingType: 'Đơn hàng có chứa kênh dịch vụ bảo trì trong dữ liệu đã chọn không thể thay đổi phương thức vận chuyển.',
  otherOverseaWarehouse: 'Kho hàng hải ngoại bên thứ ba'
}
